module.exports = __webpack_public_path__ + "static/media/bg-02.29313da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/bg-02.jpg
// module id = 373
// module chunks = 2